import { LYT21_PERIOD_OPTIONS } from 'src/components/ui-core/inputs/select/select.constants';
import {
    buildDateRangeFromPreset as buildSharedDateRangeFromPreset,
    DATE_RANGE_PRESET_IDS,
    DATE_RANGE_PRESETS,
    getDateRangePresetById,
} from 'src/constants/date-range-presets.constants';

export { DATE_RANGE_PRESET_IDS, DATE_RANGE_PRESETS, getDateRangePresetById };

const PERIOD_BY_PRESET_ID = {
    [DATE_RANGE_PRESET_IDS.YESTERDAY]: LYT21_PERIOD_OPTIONS[0].value,
    [DATE_RANGE_PRESET_IDS.LAST_WEEK]: LYT21_PERIOD_OPTIONS[1].value,
    [DATE_RANGE_PRESET_IDS.LAST_MONTH]: LYT21_PERIOD_OPTIONS[2].value,
};

export const buildDateRangeFromPreset = (presetId) => {
    const sharedRange = buildSharedDateRangeFromPreset(presetId);

    if (!sharedRange) {
        return null;
    }

    return {
        ...sharedRange,
        period: PERIOD_BY_PRESET_ID[presetId],
    };
};
